import * as React from 'react';

import useRequest from '../../common/services/request';

import commonConstants    from './common.constants';
import CommonContext      from './common.context';
import commonReducer      from './common.reducer';
import commonInitialState from './common.state';

function CommonProvider(props) {
  const {
          children,
          value,
        } = props;

  const request = useRequest();

  let initialState = {};
  if (value.pages) {
    initialState = {
      ...commonInitialState,
      pages:         Object.values(value.pages) || commonInitialState.pages,
      notifications: value.notification || commonInitialState.notifications,
      banners:       value.banners || commonInitialState.banners,
      discount:      value.discount || commonInitialState.discount,
      headSlider:    value.headSlider || commonInitialState.headSlider,

      notFoundPath: value.notFoundPath || commonInitialState.notFoundPath,
      pagesLoaded:  !!value.pages,
    };
    if (value.page) {

      for (let i = 0; i < initialState.pages.length; i++) {
        let page = initialState.pages[i];

        if (page.urlKey === value.page.urlKey) {

          initialState.pages[i] = {
            ...page, ...value.page,
          };
        }
      }
    }
  }
  const [state, dispatch] = React.useReducer(commonReducer, {
    ...commonInitialState,
    ...initialState,
  });

  const getPageData      = React.useCallback((url) => {
    dispatch({ type: commonConstants.COMMON_GET_PAGE_REQUEST });

    return request.get(`/api${url}`)
      .then((response) => dispatch({ type: commonConstants.COMMON_GET_PAGE_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: commonConstants.COMMON_GET_PAGE_FAILURE, ...error }));

  }, [dispatch]);
  const getRoutes        = React.useCallback(() => {
    dispatch({ type: commonConstants.COMMON_GET_PAGES_REQUEST });

    return request.get('/get-routes')
      .then((response) => dispatch({ type: commonConstants.COMMON_GET_PAGES_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: commonConstants.COMMON_GET_PAGES_FAILURE, ...error }));
  }, [dispatch]);
  const onChangeLocation = React.useCallback((data) => {
    return dispatch({ type: commonConstants.COMMON_CHANGE_LOCATION, ...data });
  }, [dispatch]);
  const getUrlByTemplate = React.useCallback((template) => {
    const page = state.pages.find((page) => {
      return page.template === template;
    });

    return `/${page?.urlKey ?? ''}`;
  }, [state.pages]);

  const context = React.useMemo(() => {
    return {
      ...state,
      getPageData,
      getRoutes,
      getUrlByTemplate,
      onChangeLocation,
    };
  }, [getPageData, getRoutes, getUrlByTemplate, onChangeLocation, state]);

  return (
    <CommonContext.Provider value={context}>
      {children}
    </CommonContext.Provider>
  );
}

export default CommonProvider;